import { render, staticRenderFns } from "./edc-form-additional-scores.vue?vue&type=template&id=0bc6a6f2&scoped=true&"
import script from "./edc-form-additional-scores.vue?vue&type=script&lang=js&"
export * from "./edc-form-additional-scores.vue?vue&type=script&lang=js&"
import style0 from "./edc-form-additional-scores.vue?vue&type=style&index=0&id=0bc6a6f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc6a6f2",
  null
  
)

component.options.__file = "edc-form-additional-scores.vue"
export default component.exports